import { createApp } from 'vue';
import App from './App.vue';
import router from './routers';
import store from './store/store';

import axios from 'axios';
import '@/assets/css/main.css'
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import VueGtag from "vue-gtag-next";
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { installTracker } from './analytics/tracker';

// Axios interceptor to dynamically set baseURL from store/localStorage before each request
axios.interceptors.request.use(config => {
    let tenantId = store.state.tenantId;

    // Parse URL parameters
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    // Check if any URL parameters exist
    const hasUrlParams = params.size > 0;

    if (hasUrlParams) {
        const storedParams = JSON.parse(localStorage.getItem('urlParams') || '{}');

        // Use URL parameters if present, otherwise fall back to stored parameters or defaults
        tenantId = params.get("tid") || (storedParams.tenantId ?? null);
    }

    if (tenantId) {
        config.baseURL = `https://${tenantId}.${process.env.VUE_APP_API_URL}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// Axios interceptor to redirect to 503 page on service unavailable
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 503) {
            window.location.href = '/503.html';
        }
        return Promise.reject(error);
    }
);

/**
 * Initialize Google Analytics 4 for specific tenant
 * Only enables GA4 tracking when tenantId is 'dixies'
 */
async function initializeGA4(app) {
    try {

        // Get tenantId from store or fallback sources
        let tenantId = store.state.tenantId;

        // Parse URL parameters
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);

        // Check if any URL parameters exist
        const hasUrlParams = params.size > 0;

        if (hasUrlParams) {
            const storedParams = JSON.parse(localStorage.getItem('urlParams') || '{}');

            // Use URL parameters if present, otherwise fall back to stored parameters or defaults
            tenantId = params.get("tid") || (storedParams.tenantId ?? null);
        }

        // Fetch GA4 settings from API
        const response = await axios.get(`/settings`);
        
        if (response.data && response.data.success && response.data.data) {
            // Find GA4_CODE setting
            const ga4Setting = response.data.data.find(setting => setting.key === 'GA4_CODE');
            
            if (ga4Setting && ga4Setting.value) {
                const measurementId = ga4Setting.value;
                
                // Initialize VueGtag with GA4 measurement ID
                app.use(VueGtag, {
                    property: {
                        id: measurementId
                    },
                    useDebugger: process.env.NODE_ENV === 'development'
                }, router);
                
            }
        }
    } catch (error) {
        console.error('Failed to initialize GA4 tracking:', error.message);
    }
}

// Create and configure app
const app = createApp(App);

app.use(store)
    .use(router)
    .use(VueLoading)
    .use(VueGoogleMaps, {
        load: {
            key: process.env.VUE_APP_MAP_KEY
        }
    });

// Visitor analytics (own dashboard in tour-backend)
installTracker({ router, store });

// Initialize GA4 before mounting the app
initializeGA4(app).finally(() => {
    app.mount('#app');
});
